var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4158 1.25646C11.3149 1.20027 12.2015 1.51244 12.8695 2.12431C13.4814 2.79237 13.7936 3.67895 13.7436 4.58427V10.4157C13.7998 11.321 13.4814 12.2076 12.8758 12.8757C12.2077 13.4876 11.3149 13.7997 10.4158 13.7435H4.58429C3.67897 13.7997 2.79238 13.4876 2.12432 12.8757C1.51245 12.2076 1.20027 11.321 1.25646 10.4157V4.58427C1.20027 3.67895 1.51245 2.79237 2.12432 2.12431C2.79238 1.51244 3.67897 1.20027 4.58429 1.25646H10.4158ZM6.86299 10.5283L11.0649 6.31387C11.4458 5.92677 11.4458 5.30242 11.0649 4.92157L10.2533 4.1099C9.86616 3.72281 9.2418 3.72281 8.8547 4.1099L8.43638 4.53447C8.37394 4.5969 8.37394 4.70304 8.43638 4.76548C8.43638 4.76548 9.42911 5.75196 9.44784 5.77693C9.51652 5.85185 9.56022 5.95175 9.56022 6.06413C9.56022 6.2889 9.37916 6.47621 9.14815 6.47621C9.042 6.47621 8.94211 6.4325 8.87343 6.36382L7.83075 5.32739C7.7808 5.27745 7.69339 5.27745 7.64344 5.32739L4.66525 8.30556C4.45921 8.5116 4.34058 8.78632 4.33434 9.07976L4.29688 10.5595C4.29688 10.6406 4.32185 10.7156 4.37804 10.7718C4.43423 10.828 4.50916 10.8592 4.59032 10.8592H6.05757C6.35726 10.8592 6.64446 10.7405 6.86299 10.5283Z",
    fill: "#ACABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/EditSquare.54190848c27f6275c85cb7fdce4dc924.svg";
export { ForwardRef as ReactComponent };